import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'

Vue.use(MLInstaller)

export default new MLCreate({
  initial: 'pt',
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('pt').create({
      'Já sou cadastrado': 'Já sou cadastrado',
      'Faça seu cadastro': 'Faça seu cadastro',
      'Usuário': 'Usuário',
      'Senha': 'Senha',
      'Nova Senha': 'Nova Senha',
      'Confirmar Senha': 'Confirmar Senha',
      'Nascimento': 'Nascimento',
      'Passaporte': 'Passaporte',
      'Nacionalidade': 'Nacionalidade',
      'Nome completo': 'Nome completo',
      'Nome social': 'Nome social',
      'Gênero': 'Gênero',
      'Masculino': 'Masculino',
      'Feminino': 'Feminino',
      'Outro': 'Outro',
      'Prefiro não dizer': 'Prefiro não dizer',
      'Telefone': 'Telefone',
      'Celular': 'Celular',
      'Apresenta algum tipo de deficiência': 'Apresenta algum tipo de deficiência?',
      'Escolaridade': 'Escolaridade',
      'Estuda em qual rede de ensino': 'Estuda em qual rede de ensino?',
      'Municipal': 'Municipal',
      'Estadual': 'Estadual',
      'Federal': 'Federal',
      'Particular': 'Particular',
      'Não estudo': 'Não estudo',
      'Cor/Etnia': 'Cor/Etnia',
      'Preta': 'Preta',
      'Parda': 'Parda',
      'Branca': 'Branca',
      'Amarela': 'Amarela',
      'Indígena': 'Indígena',
      'UF': 'UF',
      'Cidade': 'Cidade',
      'Bairro': 'Bairro',
      'Qual motivo do cadastro na Nave': 'Qual motivo do cadastro na Nave?',
      'Para fazer cursos e oficinas': 'Para fazer cursos e oficinas',
      'Para visitação': 'Para visitação',
      'Para acesso à internet': 'Para acesso à internet',
      'Para jogos e demais entretenimento': 'Para jogos e demais entretenimento',
      'Cód de verificação': 'Cód. de verificação',
      'Eu aceito as normas de uso e a politica de privacidade': 'Eu aceito as normas de uso e a politica de privacidade',
      'Política de Privacidade': 'Política de Privacidade',
      'Normas de Uso': 'Normas de Uso',
      'Entrar': 'Entrar',
      'Sair': 'Sair',
      'Cancelar': 'Cancelar',
      'Enviar': 'Enviar',
      'Salvar': 'Salvar',
      'Voltar': 'Voltar',
      'CPF do Responsável': 'CPF do Responsável',
      'Estrangeiro': 'Estrangeiro',
      'Esqueceu a senha?': 'Esqueceu a senha?',
      'Esqueci o login': 'Esqueci o login',
      'Digite o seu nome de usuário': 'Digite o seu nome de usuário.',
      'Digite a senha': 'Digite a senha.',
      'Autenticando': 'Autenticando...',
      'Salvando': 'Salvando...',
      'Removendo': 'Removendo...',
      'Adicionando': 'Adicionando...',
      'Login com digital': 'Login com digital',
      'Cadastro realizado com sucesso': 'Cadastro realizado com sucesso',
      'Olá, {u}': 'Olá, {u}',
      'Iniciar Visitação': 'Iniciar Visitação',
      'Perfil': 'Perfil',
      'Reservar Área': 'Reservar Área',
      'Dependentes': 'Dependentes',
      'Deseja informar nome social?': 'Deseja informar nome social?',
      'INFORME USUÁRIO E SENHA PARA ENTRAR': 'INFORME USUÁRIO E SENHA PARA ENTRAR',
      'DIRIJA-SE ATÉ A RECEPÇÃO PARA REALIZAR O SEU CADASTRO': 'DIRIJA-SE ATÉ A RECEPEÇÃO PARA REALIZAR O SEU CADASTRO',
      'Ocorreu um erro ao processar a requisição': 'Ocorreu um erro ao processar a requisição',
      'Não foi possível realizar a leitura da impressão digital': 'Não foi possível realizar a leitura da impressão digital.',
      'Seja bem-vindo e aproveite a sua visita': 'Seja bem-vindo e aproveite a sua visita.',
      'Dados atualizados com sucesso': 'Dados atualizados com sucesso.',
      'Área reservada com sucesso': 'Área reservada com sucesso.',
      'Dependente adicionado com sucesso': 'Dependente adicionado com sucesso!',
      'Dependente removido com sucesso': 'Dependente removido com sucesso!',
      'Ocorreu um erro ao remover o dependente': 'Ocorreu um erro ao remover o dependente',
      'Ocorreu um erro ao adicionar o dependente': 'Ocorreu um erro ao adicionar o dependente',
      'Senha alterada com sucesso': 'Senha alterada com sucesso!',
      'Seu usuário é: {u}': 'Seu usuário é: {u}',
      'As senhas informadas são diferentes': 'As senhas informadas são diferentes!',
      'É necessário aceitar as normas de uso e a politica de privacidade': 'É necessário aceitar as normas de uso e a politica de privacidade',
      'texto_direito_imagem': 'Autorizo a Nave do Conhecimento, assim como todos os órgãos da administração direta e indireta da Prefeitura da Cidade do Rio de Janeiro - PCRJ, bem como suas agências de publicidade e propaganda habilitadas por licitação a usar minha imagem e voz, e/ou da criança sob minha responsabilidade.',
      'texto_nome_social': '<strong>Nome Social</strong> é o nome pelo qual pessoas <u>transgênero</u> e <u>travestis</u> preferem ser chamadas, em vez de seus nomes de registro, para respeitar e reconhecer sua identidade de gênero autodeclarada. É uma forma de promover inclusão e respeito às suas identidades.',
      'As credenciais estão incorretas': 'As credenciais estão incorretas',
    }),

    new MLanguage('en').create({
      'Já sou cadastrado': 'Login',
      'Faça seu cadastro': 'Sign up',
      'Usuário': 'Username',
      'Senha': 'Password',
      'Nova Senha': 'New Password',
      'Confirmar Senha': 'Confirm password',
      'Nascimento': 'Birth date',
      'Passaporte': 'Passport',
      'Nome completo': 'Full Name',
      'Nome social': 'Social Name',
      'Nacionalidade': 'Nationality',
      'Gênero': 'Gender',
      'Masculino': 'Male',
      'Feminino': 'Female',
      'Outro': 'Other',
      'Prefiro não dizer': 'Prefer not to say',
      'Telefone': 'Phone',
      'Celular': 'Cell Phone',
      'Apresenta algum tipo de deficiência': 'Do you have any kind of disability?',
      'Escolaridade': 'Scholarity',
      'Estuda em qual rede de ensino': 'Studies in which the school system?',
      'Municipal': 'Municipal',
      'Estadual': 'State',
      'Federal': 'Federal',
      'Particular': 'Private',
      'Não estudo': 'I dont study',
      'Cor/Etnia': 'Color/Ethnicity',
      'Preta': 'Black',
      'Parda': 'Brown',
      'Branca': 'White',
      'Amarela': 'Yellow',
      'Indígena': 'Indigenous',
      'UF': 'State',
      'Cidade': 'City',
      'Bairro': 'District',
      'Qual motivo do cadastro na Nave': 'What is the reason for registering with Nave?',
      'Para fazer cursos e oficinas': 'Courses and workshops',
      'Para visitação': 'Visitation',
      'Para acesso à internet': 'Internet access',
      'Para jogos e demais entretenimento': 'Games and other entertainment',
      'Cód de verificação': 'Verification code',
      'Eu aceito as normas de uso e a politica de privacidade': 'I agree to the terms of use and the privacy policy',
      'Política de Privacidade': 'Privacy Policy',
      'Normas de Uso': 'Terms of Use',
      'Entrar': 'Enter',
      'Sair': 'Logout',
      'Cancelar': 'Cancel',
      'Enviar': 'Submit',
      'Salvar': 'Save',
      'Voltar': 'Go back',
      'CPF do Responsável': 'Responsible\' CPFs',
      'Estrangeiro': 'Foreign',
      'Esqueceu a senha?': 'Forgot Password?',
      'Esqueci o login': 'I forgot my username',
      'Digite o seu nome de usuário': 'Type your username',
      'Digite a senha': 'Type your password.',
      'Autenticando': 'Authenticating...',
      'Salvando': 'Saving...',
      'Removendo': 'Removing...',
      'Adicionando': 'Adding...',
      'Login com digital': 'Login with fingerprint',
      'Cadastro realizado com sucesso': 'Successful registration',
      'Olá, {u}': 'Hi, {u}',
      'Iniciar Visitação': 'Start Tour',
      'Perfil': 'Profile',
      'Reservar Área': 'Booking Place',
      'Dependentes': 'Dependent',
      'Deseja informar nome social?': 'Do you want to inform social name?',
      'INFORME USUÁRIO E SENHA PARA ENTRAR': 'ENTER USERNAME AND PASSWORD TO ENTER',
      'DIRIJA-SE ATÉ A RECEPÇÃO PARA REALIZAR O SEU CADASTRO': 'GO TO THE RECEPTION TO REGISTER',
      'Ocorreu um erro ao processar a requisição': 'There was an error processing the request',
      'Não foi possível realizar a leitura da impressão digital': 'Could not read the fingerprint.',
      'Seja bem-vindo e aproveite a sua visita': 'Welcome and enjoy your tour.',
      'Dados atualizados com sucesso': 'The data was successfully updated.',
      'Área reservada com sucesso': 'Successfully booking area!',
      'Dependente adicionado com sucesso': 'Dependent added successfully!',
      'Dependente removido com sucesso': 'The dependent was successfully removed!',
      'Ocorreu um erro ao remover o dependente': 'There was an error removing the dependent',
      'Ocorreu um erro ao adicionar o dependente': 'There was an error adding the dependent',
      'Senha alterada com sucesso': 'Password changed successfully!',
      'Seu usuário é: {u}': 'Your user is: {u}',
      'As senhas informadas são diferentes': 'The passwords entered are different',
      'É necessário aceitar as normas de uso e a politica de privacidade': 'You must accept the rules of use and the privacy policy',
      'texto_direito_imagem': 'I authorize Nave do Conhecimento, as well as all bodies of the direct and indirect administration of the City of Rio de Janeiro - PCRJ, as well as its publicity and advertising agencies authorized by bidding to use my image and voice, and/or the child\'s under my responsibility.',
      'texto_nome_social': 'Social name is the name by which transgender and transvestite people prefer to be called, instead of their registered names, in order to respect and recognize their self-declared gender identity. It is a way of promoting inclusion and respect for their identities.',
      'As credenciais estão incorretas': 'The user credentials were incorrect',
    }),

    new MLanguage('es').create({
      'Já sou cadastrado': 'Ya estoy registrado',
      'Faça seu cadastro': 'Haga su registro',
      'Usuário': 'Nombre de usuario',
      'Senha': 'Contraseña',
      'Nova Senha': 'Nueva contraseña',
      'Confirmar Senha': 'Confirmar contraseña',
      'Nascimento': 'Nacimiento',
      'Passaporte': 'Pasaporte',
      'Nacionalidade': 'Nacionalidad',
      'Nome completo': 'Nombre completo',
      'Nome social': 'Nombre social',
      'Gênero': 'Género',
      'Masculino': 'Masculino',
      'Feminino': 'Femenino',
      'Outro': 'Otro',
      'Prefiro não dizer': 'Prefiero no decirlo',
      'Telefone': 'Teléfono',
      'Celular': 'Celular',
      'Apresenta algum tipo de deficiência': '¿Tiene algún tipo de discapacidad?',
      'Escolaridade': 'Educación',
      'Estuda em qual rede de ensino': '¿Estudia en qué red de enseñanza?',
      'Municipal': 'Municipal',
      'Estadual': 'Estado',
      'Federal': 'Federal',
      'Particular': 'Particular',
      'Não estudo': 'No estudio',
      'Cor/Etnia': 'Cor/Etnia',
      'Preta': 'Negra',
      'Parda': 'Marrón',
      'Branca': 'Blanca',
      'Amarela': 'Amarilla',
      'Indígena': 'Indígena',
      'UF': 'UF',
      'Cidade': 'Cidade',
      'Bairro': 'Bairro',
      'Qual motivo do cadastro na Nave': 'Qual motivo do catastro na Nave?',
      'Para fazer cursos e oficinas': 'Para hacer cursos y oficinas',
      'Para visitação': 'Para visita',
      'Para acesso à internet': 'Para acceso a internet',
      'Para jogos e demais entretenimento': 'Para jogos e demais entretenimento',
      'Cód de verificação': 'Cód. De verificación',
      'Eu aceito as normas de uso e a politica de privacidade': 'Acepto las normas de uso y la política de privacidad',
      'Política de Privacidade': 'Política de privacidad',
      'Normas de Uso': 'Normas de Uso',
      'Entrar': 'Entrar',
      'Sair': 'Salir',
      'Cancelar': 'Cancelar',
      'Enviar': 'Enviar',
      'Salvar': 'Guardar',
      'Voltar': 'Regreso',
      'CPF do Responsável': 'CPF del Responsable',
      'Estrangeiro': 'Extranjero',
      'Esqueceu a senha?': '¿Olvidó la contraseña?',
      'Esqueci o login': 'Olvidé mi nombre de usuario',
      'Digite o seu nome de usuário': 'Introduzca su nombre de usuario.',
      'Digite a senha': 'Introduzca la contraseña.',
      'Autenticando': 'Autenticando...',
      'Salvando': 'Salvando...',
      'Removendo': 'Eliminando...',
      'Adicionando': 'Añadiendo...',
      'Login com digital': 'Iniciar sesión con huella digital',
      'Cadastro realizado com sucesso': 'Registro realizado con éxito',
      'Olá, {u}': '¡Hola, {u}!',
      'Iniciar Visitação': 'Comience Visitación',
      'Perfil': 'Perfil',
      'Reservar Área': 'Reservar Espacio',
      'Dependentes': 'Dependientes',
      'Deseja informar nome social?': '¿Desea informar el nombre social?',
      'INFORME USUÁRIO E SENHA PARA ENTRAR': 'INGRESE NOMBRE DE USUARIO Y CONTRASEÑA PARA INGRESAR',
      'DIRIJA-SE ATÉ A RECEPÇÃO PARA REALIZAR O SEU CADASTRO': 'IR A RECEPCIÓN PARA REGISTRARSE',
      'Ocorreu um erro ao processar a requisição': 'Se ha producido un error al procesar la solicitud',
      'Não foi possível realizar a leitura da impressão digital': 'No se pudo realizar la lectura de la huella digital.',
      'Seja bem-vindo e aproveite a sua visita': 'Bienvenido y disfruta de su visita',
      'Dados atualizados com sucesso': 'Datos actualizados correctamente.',
      'Área reservada com sucesso': '¡Área reservada con éxito!',
      'Dependente adicionado com sucesso': 'Dependiente agregado exitosamente',
      'Dependente removido com sucesso': '¡Dependiente eliminado correctamente!',
      'Ocorreu um erro ao remover o dependente': 'Hubo un error eliminando al dependiente.',
      'Ocorreu um erro ao adicionar o dependente': 'Hubo un error al agregar el dependiente.',
      'Senha alterada com sucesso': 'Contraseña cambiada con éxito.',
      'Seu usuário é: {u}': 'Tu usuario es: {u}',
      'As senhas informadas são diferentes': 'Las contraseñas introducidas son diferentes',
      'É necessário aceitar as normas de uso e a politica de privacidade': 'Debes aceptar las reglas de uso y la política de privacidad.',
      'texto_direito_imagem': 'Autorizo a Nave do Conhecimento, así como a todos los órganos de la administración directa e indirecta de la Ciudad de Rio de Janeiro - PCRJ, así como a sus agencias de publicidad y publicidad autorizadas por licitación a utilizar mi imagen y voz, y/o la del niño bajo mi responsabilidad.',
      'texto_nome_social': 'Nombre social es el nombre con el que prefieren ser llamadas las personas transgénero y travestis, en lugar de sus nombres registrados, con el fin de respetar y reconocer su identidad de género autodeclarada. Es una forma de promover la inclusión y el respeto a sus identidades.',
      'As credenciais estão incorretas': 'Las credenciales del usuario son incorrectas',
    })
  ]
})